import { render, staticRenderFns } from "./ConcurrencyEventsPanel.vue?vue&type=template&id=56a24b87&scoped=true"
import script from "./ConcurrencyEventsPanel.vue?vue&type=script&lang=js"
export * from "./ConcurrencyEventsPanel.vue?vue&type=script&lang=js"
import style0 from "./ConcurrencyEventsPanel.vue?vue&type=style&index=0&id=56a24b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a24b87",
  null
  
)

export default component.exports